import apiUtils from '@elab/core/utils/apiUtils';
import HTTPClient from '@elab/core/utils/HTTPClient';

const getApiService = () => `${apiUtils.getBaseUri()}`;

const verifyUpdatePhone = async data => {
    const uri = `${getApiService()}/updatePhoneNumberForm/`;
    const response = await HTTPClient().postJson(uri, data);

    return response.json();
};

const confirmCrm = async data => {
    const uri = `${getApiService()}/users/${data.uid}/updatePhone`;
    await HTTPClient().putJson(uri, data);
    return true;
};

export default {
    verifyUpdatePhone,
    confirmCrm,
};
